import { render } from "./CookieBanner.vue?vue&type=template&id=9a38eb12"
import script from "./CookieBanner.vue?vue&type=script&lang=js"
export * from "./CookieBanner.vue?vue&type=script&lang=js"

import exportComponent from "/Users/semetis/Desktop/Files/Projects/Personnel/KeyToSign/legal_perform_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__